import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { TestDialog } from './TestDialog.js';
import './PgDev_DialogIndexing.scss';
const Render_PgDev_DialogIndexing = () => {
    const openDialog = () => {
        ModuleFE_Dialog.show({ content: _jsx(TestDialog, {}), closeOverlayOnClick: () => false });
    };
    return _jsx("div", { className: 'pgdev-dialog-indexing', children: _jsx("div", { className: 'open-dialog-button', onClick: openDialog, children: "Click to open dialog" }) });
};
export const PgDev_DialogIndexing = {
    name: 'PgDev - Dialog Indexing',
    key: 'dialog-indexing',
    renderer: Render_PgDev_DialogIndexing
};
